import React from 'react';
import classNames from 'classnames';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { isMobile, isTablet } from 'react-device-detect';

export const ScrollButton = ({
  direction,
  onClick,
  show,
}: {
  direction: 'left' | 'right';
  onClick: () => void;
  show?: boolean;
}) => {
  const isLeft = direction === 'left';
  const Icon = isLeft ? ChevronLeftIcon : ChevronRightIcon;

  if (!show) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className={classNames('absolute z-[2] rounded-full bg-white/80 backdrop-blur-lg shadow-lg', {
        hidden: isMobile || isTablet,
        'left-2': isLeft,
        'right-2': !isLeft,
      })}
    >
      <Icon
        className="w-[40px] h-[40px] rounded-lg cursor-pointer"
        width={20}
        height={20}
        color="black/60"
      />
    </div>
  );
};

export const CTAButton = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'text-sm md:text-md text-white h-full bg-blue-light rounded-t-lg font-semibold px-2',
        'active:bg-blue-light/60',
      )}
    >
      {text}
    </button>
  );
};
